import '../globals';

;(function ($, _) {
    'use strict';

    var pluginName = 'markSearchWord';

    function Plugin(element) {
        this.element = $(element);
        this._name = pluginName;
        this.requestArguments = $.fn.requestArguments();
        this.init();

        return this;
    }

    $.extend(Plugin.prototype, {
        /**
         * Init
         */
        init: function () {
            var searchterm = this.requestArguments.getArgument('searchterm');
            if (_.isString(searchterm)) {
                this.mark(searchterm);
            }
        },

        /**
         * Mark searchterm on element
         *
         * @param searchterm
         */
        mark: function (searchterm) {
            var that = this;
            that.element.unmark({
                done: function() {
                    that.element.mark(searchterm);
                }
            });
        }
    });

    /**
     * Plugin wrapper
     */
    $.fn[pluginName] = function () {
        return this.each(function () {
            if (!$.data(this, 'plugin_' + pluginName)) {
                $.data(this, 'plugin_' + pluginName, new Plugin(this));
            } else {
                $.data(this, 'plugin_' + pluginName).init();
            }
        });
    };
})(jQuery, _);
